<!--
 * @Date: 2020-07-22 09:57:52
 * @LastEditTime: 2020-11-27 10:09:55
 * @Description: 调度任务
--> 

<template>
  <div class="container">
    <div class="top-search">
      <div class="search">
        <div class="content">
          <el-form :model="searchParams" inline>
            <el-form-item label="App_ID" prop="roleName">
              <el-input
                v-model="searchParams.name"
                placeholder="请输入创建爬取任务的APP_ID"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
            <el-form-item label="爬虫ID" prop="roleName">
              <el-input
                v-model="searchParams.addr"
                placeholder="请输入爬虫的实例ID"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="search-btns">
          <div class="left-line" />
          <div class="right-btns mg">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              class="search-btn"
              @click="rowAdd"
              >创建任务</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              class="search-btn"
              @click="search"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              round
              class="reset-btn"
              @click="reset"
              >重置</el-button
            >
          </div>
          <div class="left-line" />
        </div>
      </div>
    </div>

    <div class="table-container">
      <!-- <div class="table-title">当前App：{{curAppName}}</div> -->

      <el-table
        :data="
          list.slice(
            (pagination.page - 1) * pagination.limit,
            pagination.page * pagination.limit
          )
        "
        v-loading="loading"
        empty-text="暂无数据"
        style="width: 100%"
        height="600"
        :row-style="{ background: '#FCFDFF' }"
        :header-cell-style="{ background: '#2d3a5b', color: '#ffffff' }"
      >
        <el-table-column align="center" label="App_ID">
          <template slot-scope="scope">
            <span>{{ scope.row.app }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="爬虫类型">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_type === 1 ? "收入" : "支出" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="爬虫ID" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.channel_id }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="调度方式" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{
              scope.row.schedule_type === 1 ? "定时调度" : "间隔调度"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="执行主机" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.exec_host }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="代理主机" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.proxy }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="changeSwitch($event, scope.row)"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="rowUpdate(row)"
              >修改</el-button
            >
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              @click="rowDelete(row)"
              >删除</el-button
            >
            <el-button
              type="text"
              size="mini"
              icon="el-icon-refresh"
              @click="rowMakePlan(row)"
              >重新规划</el-button
            >
            <el-button
              type="text"
              size="mini"
              icon="el-icon-s-claim"
              @click="rowPlan(row)"
              >执行计划</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
    />

    <!-- 修改 新增 dialog -->
    <el-dialog :visible.sync="dialogForm" :title="dialogFormTitle">
      <el-form
        :model="formTemp"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="app" prop="app">
              <el-input
                type="number"
                placeholder="请输入爬取任务的APP_id"
                v-model="formTemp.app"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="爬虫类型" prop="channel_type">
              <el-select v-model="formTemp.channel_type" placeholder="请选择">
                <el-option
                  v-for="item in optionsType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="爬虫Id" prop="channel_id">
              <el-input
                type="number"
                placeholder="请输入爬取的实例id"
                v-model="formTemp.channel_id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="调度方式" prop="schedule_type">
              <el-select v-model="formTemp.schedule_type" placeholder="请选择">
                <el-option
                  v-for="item in optionsDu"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="执行固定时间点"
              prop="schedule_at"
              :rules="{
                required: formTemp.schedule_type == 1 ? true : false,
                message: '请选择执行固定时间点',
                trigger: 'change',
              }"
            >
              <el-time-picker
                v-model="formTemp.schedule_at"
                placeholder="请选择"
                format="HH:mm"
                value-format="HH:mm"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="执行间隔时间"
              prop="schedule_inter_val"
              :rules="{
                required: formTemp.schedule_type == 2 ? true : false,
                message: '请输入执行间隔时间',
                trigger: 'blur',
              }"
            >
              <el-input
                type="number"
                placeholder="请输入执行间隔时间(分钟)"
                v-model="formTemp.schedule_inter_val"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大重试次数" prop="enabled">
              <el-input
                type="number"
                placeholder="请输入最大重试次数"
                v-model="formTemp.max_retry"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大执行耗时" prop="enabled">
              <el-input
                type="text"
                placeholder="请输入最大执行耗时"
                v-model="formTemp.exec_timeout"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="额外参数	" prop="enabled">
              <el-input
                type="text"
                placeholder="请输入额外的参数"
                v-model="formTemp.extra_params"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="enabled">
              <el-switch
                v-model="formTemp.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行主机	" prop="enabled">
              <el-input
                type="text"
                placeholder="请输入执行的目标主机"
                v-model="formTemp.exec_host"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理主机	" prop="enabled">
              <el-input
                type="text"
                placeholder="请输入执行使用的代理主机"
                v-model="formTemp.proxy"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="reset-btn" @click="dialogForm = false"
          >取消</el-button
        >
        <el-button type="primary" class="search-btn" @click="submitForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  taskList,
  taskCreate,
  taskMakePlan,
  taskUpdate,
  taskDelete,
} from "@/api/task.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      curAppName: "",
      loading: false,
      dialogDetail: false,
      dialogForm: false,
      dialogFormTitle: "",
      searchParams: {
        name: "",
        tel: "",
        addr: "",
      },
      optionsType: [
        {
          value: 1,
          label: "收入类别",
        },
        {
          value: 2,
          label: "支出类别",
        },
      ],
      optionsDu: [
        {
          value: 1,
          label: "定时调度",
        },
        {
          value: 2,
          label: "间隔调度",
        },
      ],
      pagination: {
        limit: 30,
        page: 1,
        total: 0,
      },
      list: [],
      curRowId: 0,
      formTemp: {
        app: null,
        channel_type: "",
        channel_id: "",
        schedule_type: "",
        schedule_at: "",
        schedule_inter_val: "",
        max_retry: "",
        exec_timeout: "",
        extra_params: "",
        status: 0,
        exec_host: "",
        proxy: "",
      },
      formDetail: {},
      rules: {
        app: [{ required: true, message: "请输入App_id", trigger: "blur" }],
        channel_type: [
          { required: true, message: "请选择爬虫类型", trigger: "change" },
        ],
        channel_id: [
          { required: true, message: "请输入爬虫实例ID", trigger: "blur" },
        ],
        schedule_type: [
          { required: true, message: "请选择调度方式", trigger: "change" },
        ],
      },
    };
  },

  created() {
    this.curAppName = "";

    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;
      taskList({ id: localStorage.getItem("curAppId") })
        .then((res) => {
          this.loading = false;
          this.list = res;
          this.pagination.total = res.length;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    changeSwitch(e, row) {
      let _copy = Object.assign({}, row);
      _copy.status = e;
      taskUpdate(_copy).then(() => {
        if (e) {
          this.notice("启用成功");
        } else {
          this.notice("禁用成功");
        }
      });
    },

    rowPlan(row) {
      this.$router.push({
        path: "/projectManager/plan",
        query: { app: this.$route.query.id, task: row.id },
      });
    },

    search() {},
    reset() {},

    rowAdd() {
      this.resetValue(
        "新增主机",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        false,
        "",
        "",
        0
      );
    },
    rowUpdate(row) {
      this.resetValue(
        "修改主机",
        row.app,
        row.channel_type,
        row.channel_id,
        row.schedule_type,
        row.schedule_at,
        row.schedule_inter_val,
        row.max_retry,
        row.exec_timeout,
        row.extra_params,
        row.status,
        row.exec_host,
        row.proxy,
        row.id
      );
    },

    resetValue(
      title,
      app,
      channel_type,
      channel_id,
      schedule_type,
      schedule_at,
      schedule_inter_val,
      max_retry,
      exec_timeout,
      extra_params,
      status,
      exec_host,
      proxy,
      id
    ) {
      this.dialogForm = true;
      this.dialogFormTitle = title;
      this.formTemp.app = app;
      this.formTemp.channel_type = channel_type;
      this.formTemp.channel_id = channel_id;
      this.formTemp.schedule_type = schedule_type;
      this.formTemp.schedule_at = schedule_at;
      this.formTemp.schedule_inter_val = schedule_inter_val;
      this.formTemp.max_retry = max_retry;
      this.formTemp.exec_timeout = exec_timeout;
      this.formTemp.extra_params = extra_params;
      this.formTemp.status = status;
      this.formTemp.exec_host = exec_host;
      this.formTemp.proxy = proxy;

      this.curRowId = id;
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },

    rowMakePlan(row) {
      this.$confirm("任务每天会自动规划一次", "重新规划执行计划", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          taskMakePlan({ id: row.id }).then(() => {
            this.notice("规划成功");
          });
        })
        .catch(() => {});
    },

    rowDelete(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          taskDelete({ id: row.id }).then(() => {
            this.notice("删除成功");
          });
        })
        .catch(() => {});
    },

    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.curRowId === 0) {
            //新增
            taskCreate(this.formTemp).then(() => {
              this.dialogForm = false;
              this.notice("新增成功！");
            });
          } else {
            let _copy = Object.assign({}, this.formTemp);
            _copy.id = this.curRowId;
            //修改
            taskUpdate(_copy).then(() => {
              this.dialogForm = false;
              this.notice("修改成功！");
            });
          }
        } else {
          return false;
        }
      });
    },

    notice(message) {
      this.$notify({
        title: "成功",
        message,
        type: "success",
      });
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.container {
  margin: 20px;
}

.top-search {
  display: flex;
  padding: 20px;
  width: 100%;
  // height: 100px;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  // border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  // width: 1160px;
  // height: 160px;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  // margin: 0 auto;
  //   overflow: hidden;
  .content {
    @include flex(center, space-between);
    border-radius: 4px;
    // height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}
.table-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #2d3a5b;
  background-color: #ffffff;
}
</style>
